export default __webpack_public_path__ + "static/media/39_1_3.8632d616.png";